import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Styles
import './miniProduct.styles.scss';

export default class MiniProduct extends Component {
    componentDidMount() {
        const { getProductData, data } = this.props;

        if (data && !data.productName) {
            getProductData(data.articleNumber, data.articleType, data.quantity);
        }
    }


    render() {
        const { data, showInfo, showProductId, quantity } = this.props;
        let className = 'miniproduct';
        className += ` miniproduct__${showInfo ? 'with' : 'without'}-info`;
        className += ` miniproduct__${showProductId ? 'with' : 'without'}-product-id`;

        // Product data is not loaded yet, show a placeholder until it's retrieved
        if (!data || typeof data.productName === 'undefined') {
            return (
                <div className={className}/>
            );
        }

        return (
            <div className={className}>
                <img
                    src={'https://www.ikea.com' + data.s3Image}
                    alt={`IKEA ${data.productName} ${data.productType}`}
                    itemProp="image"
                    width="101"
                    height="101"
                />
                {!showInfo &&
                    <sup className="miniproduct__quantity">{quantity || data.quantity}</sup>
                }
                {showInfo &&
                    <div className="miniproduct__data">
                        <p>{quantity || data.quantity} × <b>{data.productName}</b></p>
                        <p>{data.productType}</p>
                        {showProductId &&
                            <p>{data.articleNumber.toString().match(/\d{1,3}/g).join('.')}</p>
                        }
                    </div>
                }
            </div>
        );
    }
}

MiniProduct.propTypes = {
    productId: PropTypes.any.isRequired,
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    getProductData: PropTypes.func.isRequired,
    showInfo: PropTypes.bool,
    showProductId: PropTypes.bool,
    assemblyServiceProducts: PropTypes.object,
    quantity: PropTypes.number,
};
